// Initialize accordions
function initProductDescription() {

    const container = document.getElementById("js-product-description-container");
    const productDescription = container.querySelector("#js-product-description");

    const descriptionFade = container.querySelector("#js-product-description-fade");
    
    const buttonReadMore = container.querySelector("button#js-product-description-read-more");
    const buttonReadLess = container.querySelector("button#js-product-description-read-less");

    console.log(productDescription.offsetHeight);

    // Function to close an accordion
    const closeProductDescription = () => {
        container.style.height = "240px";
        descriptionFade.style.opacity = 1;
        buttonReadMore.style.display = "block";
        buttonReadLess.style.display = "none";
    };

    const openProductDescription = () => {
        container.style.height = productDescription.offsetHeight + "px";
        descriptionFade.style.opacity = 0;
        buttonReadMore.style.display = "none";
        buttonReadLess.style.display = "block";
    };

    if (productDescription.offsetHeight > 320) {

        buttonReadMore.addEventListener("click", () => {
            openProductDescription();
        });

        buttonReadLess.addEventListener("click", () => {
            closeProductDescription();
        });

    } else {

        container.style.height = "auto";
        descriptionFade.style.opacity = 0;
        descriptionFade.style.display = "none";
        buttonReadMore.style.display = "none";
        buttonReadLess.style.display = "none";

    }
}
  
// Initialize accordions when DOM is loaded
document.addEventListener('DOMContentLoaded', initProductDescription);

// Re-initialize accordions when sections are loaded
document.addEventListener('shopify:section:load', initProductDescription);